import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
 
export const usePageTracking = () => {
    const location = useLocation();
    const debounceTimer = useRef(null);
 
    useEffect(() => {
        // Only track root path
        if (location.pathname !== "/") return;
 
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
 
        debounceTimer.current = setTimeout(() => {
            axios.post(`${process.env.REACT_APP_API_URL}/api/analytics/visits/track`, null, {
                params: { pageName: "/" }
            }).catch(() => {});
        }, 500);
 
        return () => clearTimeout(debounceTimer.current);
    }, [location.pathname]);
};